(ns frontend.view.grid.tenant-kyc-grid.db
  (:require
   [frontend.db :as app-db]
   [reagent.core :as r]))

(defonce tenant-kyc-profiles (r/cursor app-db/views [:tenant-kyc-grid]))
(defonce modal-state (r/cursor tenant-kyc-profiles [:modals]))
(defonce grid-entities (r/cursor tenant-kyc-profiles [:grid-entities]))
(defonce view-settings (r/cursor tenant-kyc-profiles [:view-settings]))
(defonce tenant-kyc-profile-filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))

;;kanban related definitions
(defonce kanban (r/cursor tenant-kyc-profiles [:kanban]))
(defonce expanded (r/cursor kanban [:expanded]))
(defonce grouped-by (r/cursor view-settings [:grouped-by]))
(defonce card-settings (r/cursor view-settings [:card-settings]))
(defonce lists (r/cursor kanban [:lists]))
(defonce sorted-kanban-entities (r/cursor tenant-kyc-profiles [:sorted-kanban-entities]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor tenant-kyc-profiles [:schema]))
